import { Download } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface FetchingTicketsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

// Small, dismissible confirmation — the fetch keeps running in the background
// (surfaced later via "My Ticket Categories") even after this is closed.
export function FetchingTicketsDialog({ open, onOpenChange }: FetchingTicketsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='w-[calc(100vw-2rem)] max-w-sm p-4'>
        <DialogHeader>
          <div className='size-8 rounded-md border flex items-center justify-center mb-1'>
            <Download className='size-4' />
          </div>
          <DialogTitle className='text-sm font-semibold'>Fetching Tickets</DialogTitle>
          <p className='text-xs text-muted-foreground'>
            Your tickets are being fetched and will draft protocols from them. This might take a while
          </p>
        </DialogHeader>

        <div className='flex justify-end mt-2'>
          <Button type='button' className='text-xs' onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
